
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

export default {
name: "loan",
components: {
XHeader,Group,Selector,XInput
},
data() {
return {
title: "缓缴申请",
stuinfo:{
name:'张三',
sex:'男',
year:'2007',
idcard:'110000000000000000',
depart:'XX学院',
major:'XX自动化',
class:'1701',
},
state:0,
delayinfo:{
applyyear:'2007',
idcard:'110000000000000000',
money:'8000',
pic:''
},
delay:{
year:'',
img:'',
idcard:'',
money:'',
}
}
},
methods:{
goedit(){
this.state=1;
},
reedit(){
this.state=0;
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/delay.vue